<template>
  <v-row
    no-gutters
    dense
  >
    <v-col
      cols="12"
    >
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-card
          outlined
        >
          <v-card-text>
            <v-row
              dense
              no-gutters
            >
              <v-col
                cols="12"
              >
                <v-btn
                  v-if="typeof $store.state.user.auth_token !== 'undefined'
                    && $store.state.user.auth_token !== null"
                  x-small
                  color="success"
                  @click="copyProfile()">Use profile</v-btn>
                <v-btn
                  v-if="typeof $store.state.user.auth_token !== 'undefined'
                    && $store.state.user.auth_token !== null"
                  x-small
                  color="warning"
                  @click="clearProfile()">Clear</v-btn>
                <profile
                  ref="partnerProfile"
                  :setNewProfile="profile"
                ></profile>
                <v-row dense>
                  <v-col cols="6" class="text-right">
                    <v-text-field
                      dense
                      label="Personal Identity No: NRIC No./FIN No. for .sg tld"
                      v-model="personal_identity_no"></v-text-field>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <v-text-field
                      dense
                      label="Corporate No: UEN/Entity No./CorpPass No. for .sg tld"
                      v-model="corporate_no"></v-text-field>
                  </v-col>
                </v-row>
                <v-row
                  dense
                >
                  <v-col
                    cols="12"
                    class="text-right"
                  >
                    <v-btn
                      color="primary"
                      :loading="processing"
                      @click="submitForm"
                    >Submit</v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import Profile from '../../components/Profile.vue';

export default {
  name: 'DomainDefaultContact',
  components: {
    Profile,
  },
  created() {
    this.$api.get('partner/domain/default-contact').then((response) => {
      this.setProfile(response.data.profile);
    });
  },
  data() {
    return {
      processing: false,
      profile: null,
      personal_identity_no: null,
      corporate_no: null,
      rules: {
        required: (value) => !!value || 'This field is required.',
        isNumeric: (value) => this.$underscore.isFinite(value) || 'This field must be numeric.',
      },
      valid: false,
    };
  },
  methods: {
    setProfile(profile) {
      if (!this.$underscore.isEmpty(profile.email)) {
        this.profile = profile;
        this.corporate_no = profile.corporate_no;
        this.personal_identity_no = profile.personal_identity_no;
      }
    },
    copyProfile() {
      this.$api.get('partner/profile').then((response) => {
        this.profile = {
          first_name: response.data.first_name,
          last_name: response.data.last_name,
          email: response.data.email,
          company_name: response.data.company_name,
          address1: response.data.address1,
          address2: '',
          city: response.data.city,
          state: response.data.state,
          country: response.data.country,
          postal_code: response.data.postal_code,
          phone_country_code: response.data.phone_country_code,
          phone: response.data.phone,
          fax_country_code: '',
          fax: '',
        };
      });
    },
    clearProfile() {
      this.profile = {
        first_name: '',
        last_name: '',
        email: '',
        company_name: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        country: 'SG',
        postal_code: '',
        phone_country_code: '65',
        phone: '',
        fax_country_code: '',
        fax: '',
      };
      this.corporate_no = '';
      this.personal_identity_no = '';
    },
    submitForm() {
      this.processing = true;
      if (this.$refs.form.validate()) {
        const formData = this.$refs.partnerProfile.getProfileData();
        formData.corporate_no = this.corporate_no;
        formData.personal_identity_no = this.personal_identity_no;
        this.$api.put('partner/domain/default-contact', formData)
          .then(() => {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'success',
              message: 'Domain default contact is updated successfully.',
            });
          }).finally(() => {
            this.processing = false;
          });
      } else {
        this.processing = false;
      }
    },
  },
};
</script>
<style scoped></style>
